module.exports = __webpack_public_path__ + "media/images/lp/lp22-951c90ce45dae01c5a3ed868e4cb684e.webp";